import { Stack } from "@mui/material";
import AllSidesCategoryIcon from "./AllSidesCategoryIcon";

export default function AllSidesRating({
  activeCategory,
  size = "medium",
  single = false,
  className,
  hash,
}) {
  if (!["small", "medium", "large"].includes(size)) {
    console.error(
      Error("Size prop only allows 'small', 'medium', and 'large' values")
    );
    return null;
  }
  const renderSingleCategoryIcon = (category) => {
    switch (category) {
      case "Left":
        return (
          <AllSidesCategoryIcon
            size={size}
            category="L"
            color="#126ba3"
            active
            title={category}
          />
        );
      case "Lean Left":
        return (
          <AllSidesCategoryIcon
            size={size}
            category="L"
            color="#a3becf"
            active
            title={category}
          />
        );
      case "Center":
        return (
          <AllSidesCategoryIcon
            size={size}
            category="C"
            color="#6e3aa6"
            active
            title={category}
          />
        );
      case "Lean Right":
        return (
          <AllSidesCategoryIcon
            size={size}
            category="R"
            color="#d28c9f"
            active
            title={category}
          />
        );
      case "Right":
        return (
          <AllSidesCategoryIcon
            size={size}
            category="R"
            color="#a10830"
            active
            title={category}
          />
        );
      default:
        return null; // Handle edge cases where activeCategory doesn't match
    }
  };

  return !single ? (
    <Stack direction="row" gap={0.5}>
      <AllSidesCategoryIcon
        size={size}
        category="L"
        color="#126ba3"
        active={activeCategory === "Left"}
        title={activeCategory === "Left" ? activeCategory : null}
      />
      <AllSidesCategoryIcon
        size={size}
        category="L"
        color="#a3becf"
        active={activeCategory === "Lean Left"}
        title={activeCategory === "Lean Left" ? activeCategory : null}
      />
      <AllSidesCategoryIcon
        size={size}
        category="C"
        color="#6e3aa6"
        active={activeCategory === "Center"}
        title={activeCategory === "Center" ? activeCategory : null}
      />
      <AllSidesCategoryIcon
        size={size}
        category="R"
        color="#d28c9f"
        active={activeCategory === "Lean Right"}
        title={activeCategory === "Lean Right" ? activeCategory : null}
      />
      <AllSidesCategoryIcon
        size={size}
        category="R"
        color="#a10830"
        active={activeCategory === "Right"}
        title={activeCategory === "Right" ? activeCategory : null}
      />
    </Stack>
  ) : (
    <Stack
      className={className}
      data-article-id={hash}
      direction="row"
      gap={0.5}
    >
      {renderSingleCategoryIcon(activeCategory)}
    </Stack>
  );
}
